var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgICameraBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 5.43H14.65L14.09 4.47C13.83 4.02 13.35 3.75 12.84 3.75H9.16C8.64 3.75 8.17 4.02 7.91 4.47L7.35 5.43H4.25C2.87 5.43 1.75 6.55 1.75 7.93V15.75C1.75 17.13 2.87 18.25 4.25 18.25H17.75C19.13 18.25 20.25 17.13 20.25 15.75V7.93C20.25 6.55 19.13 5.43 17.75 5.43Z",
    stroke: "#1065D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0004 15.24C12.9886 15.24 14.6004 13.6283 14.6004 11.64C14.6004 9.65181 12.9886 8.04004 11.0004 8.04004C9.01217 8.04004 7.40039 9.65181 7.40039 11.64C7.40039 13.6283 9.01217 15.24 11.0004 15.24Z",
    fill: "#1065D9",
    stroke: "#1065D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2702 9.29047C17.8391 9.29047 18.3002 8.82932 18.3002 8.26047C18.3002 7.69162 17.8391 7.23047 17.2702 7.23047C16.7014 7.23047 16.2402 7.69162 16.2402 8.26047C16.2402 8.82932 16.7014 9.29047 17.2702 9.29047Z",
    fill: "#1065D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18023 4.28027H3.99023V5.44027H6.18023V4.28027Z",
    fill: "#1065D9",
    stroke: "#1065D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8362 2.28196L21.4731 2.37534C20.6908 2.57868 20.0787 3.1908 19.8753 3.97307L19.782 4.33619C19.7591 4.42127 19.6409 4.42127 19.618 4.33619L19.5247 3.97307C19.3213 3.1908 18.7092 2.57868 17.9269 2.37534L17.5638 2.28196C17.4787 2.25914 17.4787 2.14086 17.5638 2.11804L17.9269 2.02466C18.7092 1.82132 19.3213 1.2092 19.5247 0.426928L19.618 0.0638057C19.6409 -0.0212686 19.7591 -0.0212686 19.782 0.0638057L19.8753 0.426928C20.0787 1.2092 20.6908 1.82132 21.4731 2.02466L21.8362 2.11804C21.9213 2.14086 21.9213 2.25914 21.8362 2.28196Z",
    fill: "#1065D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgICameraBlue);
export default __webpack_public_path__ + "static/media/i_camera_blue.193288e02a8f82dac4a4e7bf190f3fae.svg";
export { ForwardRef as ReactComponent };